var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 2.09668H13.3333C13.5101 2.09668 13.6797 2.16692 13.8047 2.29194C13.9298 2.41697 14 2.58654 14 2.76335V14.666C14 14.8428 13.9298 15.0124 13.8047 15.1374C13.6797 15.2624 13.5101 15.3327 13.3333 15.3327H2.66667C2.48986 15.3327 2.32029 15.2624 2.19526 15.1374C2.07024 15.0124 2 14.8428 2 14.666V2.76335C2 2.58654 2.07024 2.41697 2.19526 2.29194C2.32029 2.16692 2.48986 2.09668 2.66667 2.09668H3",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.99935H9.33333C9.33333 1.64573 9.19286 1.30659 8.94281 1.05654C8.69276 0.806491 8.35362 0.666016 8 0.666016C7.64638 0.666016 7.30724 0.806491 7.05719 1.05654C6.80714 1.30659 6.66667 1.64573 6.66667 1.99935H5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.6832C4 11.8999 4.04268 12.1144 4.1256 12.3146C4.20852 12.5148 4.33006 12.6967 4.48327 12.8499C4.63649 13.0031 4.81839 13.1247 5.01857 13.2076C5.21876 13.2905 5.43332 13.3332 5.65 13.3332C5.86668 13.3332 6.08124 13.2905 6.28143 13.2076C6.48161 13.1247 6.66351 13.0031 6.81673 12.8499C6.96994 12.6967 7.09148 12.5148 7.1744 12.3146C7.25732 12.1144 7.3 11.8999 7.3 11.6832C7.3 11.4665 7.25732 11.252 7.1744 11.0518C7.09148 10.8516 6.96994 10.6697 6.81673 10.5165C6.66351 10.3633 6.48161 10.2417 6.28143 10.1588C6.08124 10.0759 5.86668 10.0332 5.65 10.0332C5.43332 10.0332 5.21876 10.0759 5.01857 10.1588C4.81839 10.2417 4.63649 10.3633 4.48327 10.5165C4.33006 10.6697 4.20852 10.8516 4.1256 11.0518C4.04268 11.252 4 11.4665 4 11.6832Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72876 6.5459L12.2714 9.08923",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2714 6.5459L9.72876 9.08923",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29272 7.81823C4.54387 7.05229 5.04711 6.39403 5.72038 5.95079C6.39364 5.50756 7.19722 5.3055 8.00006 5.37757",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99658 4.26465L7.99992 5.37665L7.15992 6.58798",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/plan.e58b6f28.svg";
export { ForwardRef as ReactComponent };